import angular from 'angular';

import drawerModule from '../ui/drawer/drawer.module';
import unitSearchPanelModule from '../unit.search.panel/unit.search.panel.module';
import { unitSearchHeader } from './unit.search.header.directive';

import './unit.search.header.scss';

export default angular
  .module('unit.search.header', [drawerModule.name, unitSearchPanelModule.name])
  .directive('unitSearchHeader', unitSearchHeader);
